import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import styles from './Toasts.module.css';
function Toast({ item, autoDeleteTime = 2500, actions }) {
    const [time, setTime] = useState(0);
    const [unmountTransition, setUnmountTransition] = useState(false);
    useEffect(() => {
        if (item.autoDeleteTime) {
            const setTimeInterval = setInterval(() => setTime((state) => state + 40), 40);
            const interval = setInterval(() => {
                setUnmountTransition(true);
                clearInterval(setTimeInterval);
            }, autoDeleteTime);
            return () => {
                clearInterval(interval);
                clearInterval(setTimeInterval);
            };
        }
        return undefined;
    }, []);
    return (_jsxs("div", { className: `${styles.toast} ${(unmountTransition) ? styles.hideToast : ''}`, onAnimationEnd: () => {
            if (unmountTransition && item.id) {
                actions.removeToast(item.id);
            }
        }, children: [_jsx("div", { className: styles.time, style: {
                    backgroundColor: item.color,
                    width: (item.autoDeleteTime) ? `${(time * 100) / autoDeleteTime}%` : '100%',
                } }), _jsxs("div", { className: styles.content, children: [_jsx("i", { style: { color: item.color }, children: item.icon }), _jsxs("div", { className: styles.textContainer, children: [_jsx("p", { className: styles.title, children: item.title }), _jsx("p", { className: styles.description, children: item.description })] }), _jsx("button", { type: "button", "aria-label": "Close", className: styles.button, onClick: () => setUnmountTransition(true), children: _jsx(Close, { className: styles.icon }) })] })] }));
}
export default function Toasts({ list, autoDeleteTime, actions }) {
    return (_jsx("div", { className: styles.toastContainer, children: list && list.map((toast) => (_jsx(Toast, { item: toast, autoDeleteTime: autoDeleteTime, actions: actions }, toast.id))) }));
}
